"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../../constants");
exports.CustomerSchema = joi_1.default.object({
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    name: joi_1.default.string().required(),
    notifyLocation: joi_1.default.boolean().required(),
    notificationEmail: joi_1.default.string()
        .email({ tlds: { allow: !constants_1.isBrowser } })
        .allow(null),
    amNotificationWay: joi_1.default.string().allow(null, 'email+central', 'email', 'none', 'central'),
    organizationUuid: joi_1.default.string().uuid().required(),
    prepaid: joi_1.default.boolean().required(),
    salesforceId: joi_1.default.string().required(),
    productUuids: joi_1.default.array().items(joi_1.default.string().uuid()).allow(null),
    locationGuidelinesUrl: joi_1.default.string().uri().allow(null),
    locationCancellationBlockingHours: joi_1.default.number().allow(null),
    locationReminderEmailBeforeHours: joi_1.default.number().allow(null),
    externalIdRequired: joi_1.default.boolean().allow(null)
}).meta({ className: 'Customer' });
//# sourceMappingURL=CustomerSchema.js.map